import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as Assets from '../../utils/svg_assets';
import { getCurrentTime } from '../../utils/utilities';
import * as Pages from './../../utils/route_pages';
import { priceDecimal } from '../../utils/utilities';

const PointInfo = () => {
  const navigate = useNavigate();
  const { first_name: firstName } = useSelector(
    (state) => state.LoginSM.login.user_details
  );
  const { current_user_point: currentPoint } = useSelector(
    (state) => state.FeedsSM.feedDataDashboard
  );

  return (
    <div className="d-flex justify-content-between m-3 mt-5">
      <div>
        {getCurrentTime(new Date())}, {firstName}!
      </div>
      <div
        className="d-flex align-items-center"
        onClick={() => navigate(Pages.homePointSummary)}
      >
        <img src={Assets.iconOval} alt="icon-arrow-right" />
        &nbsp;&nbsp;
        <span className="font-bold">{priceDecimal(currentPoint)}</span>
        &nbsp; Points &nbsp;
        <img src={Assets.iconArrowRight} alt="icon-arrow-right" />
      </div>
    </div>
  );
};

export default PointInfo;
